import "materialize-css";

const MaterialTooltipDirective = function ($timeout) {
    // Without '$timeout' the tooltips text is shown as angular interploation text. for ex: ({{::column.Tooltip}}), not the angular evaluated value.
    return function (scope, element, attrs) {
        $timeout(function () {
            element.tooltip();
        })
    }
};

MaterialTooltipDirective.$inject = ["$timeout"];

export { MaterialTooltipDirective };